import styled from 'styled-components'

export const AddressContainer = styled.div`
  &.address-container {
    overflow: hidden;
    max-height: 0;
    transition: max-height 1.1s ease;
    margin-bottom: 20px;

    &--show {
      max-height: 1600px;
    }
  }
`
